import { PAGE_TYPE_CHANGE } from 'constants/reduxActions';
import { trackPageRequest } from 'events/ops/opsEvent';

/**
 * Redux middleware that fires a PAGE_REQUEST ops event on every
 * PAGE_TYPE_CHANGE action. This covers both initial page load (component
 * mount during hydration) and client-side SPA navigations, since every
 * page container dispatches pageTypeChange on mount.
 *
 * Serves as the denominator for error page and uncaught exception rate metrics.
 */
export const pageRequestMiddleware = () => (next: Function) => (action: { type: string; pageType?: string }) => {
  const result = next(action);

  if (action.type === PAGE_TYPE_CHANGE && action.pageType) {
    trackPageRequest(action.pageType);
  }

  return result;
};
